import {
  ScheduleComparison, ComparisonMetrics, ComparisonCost, ComparisonDeltas, Caveat,
} from "../../../models/ScheduleComparison";

const cost = (c: any): ComparisonCost => ({
  fuel: Number(c?.fuel ?? 0),
  wage: Number(c?.wage ?? 0),
  dumpFees: Number(c?.dump_fees ?? 0),
  maintenance: Number(c?.maintenance ?? 0),
  operating: Number(c?.operating ?? 0),
  compactness: Number(c?.compactness ?? 0),
  overtime: Number(c?.overtime ?? 0),
  timeWindow: Number(c?.time_window ?? 0),
  endTime: Number(c?.end_time ?? 0),
  balance: Number(c?.balance ?? 0),
  penalties: Number(c?.penalties ?? 0),
  total: Number(c?.total ?? 0),
});

const metrics = (m: any): ComparisonMetrics => ({
  driversUsed: Number(m?.drivers_used ?? 0),
  dumpStops: Number(m?.dump_stops ?? 0),
  drivingSeconds: Number(m?.driving_seconds ?? 0),
  serviceSeconds: Number(m?.service_seconds ?? 0),
  totalSeconds: Number(m?.total_seconds ?? 0),
  meters: Number(m?.meters ?? 0),
  cost: cost(m?.cost),
});

const caveat = (c: any): Caveat => ({
  type: String(c?.type ?? ""),
  severity: (c?.severity ?? "low") as Caveat["severity"],
  message: String(c?.message ?? ""),
  affectedIds: c?.affected_ids,
});

const deltas = (d: any): ComparisonDeltas => ({
  driversUsed: Number(d?.drivers_used ?? 0),
  drivingSeconds: Number(d?.driving_seconds ?? 0),
  meters: Number(d?.meters ?? 0),
  costTotal: Number(d?.cost_total ?? 0),
});

export function getScheduleComparison(data: any): ScheduleComparison {
  return {
    id: String(data?.id ?? ""),
    date: String(data?.date ?? ""),
    fleetOptimizationId: String(data?.fleet_optimization_id ?? ""),
    benchmarkOptionIndex: Number(data?.benchmark_option_index ?? 0),
    benchmark: metrics(data?.benchmark),
    actual: metrics(data?.actual),
    deltas: deltas(data?.deltas),
    comparable: Boolean(data?.comparable),
    caveats: Array.isArray(data?.caveats) ? data.caveats.map(caveat) : [],
    createdBy: {
      type: String(data?.created_by?.type ?? ""),
      id: String(data?.created_by?.id ?? ""),
      name: String(data?.created_by?.name ?? ""),
    },
    createdAt: String(data?.created_at ?? ""),
  };
}

export function getScheduleComparisons(data: any): ScheduleComparison[] {
  const arr = Array.isArray(data) ? data : Array.isArray(data?.comparisons) ? data.comparisons : [];
  return arr.map(getScheduleComparison);
}
